import { getUserPermissionsList, superPermission } from "../util/permissionsUtils";
import getHazardsList from "./hazardsConfigList/allHazardsList";

export const getEnumKeyByValue = <T extends Record<string, string>>(
  enumObject: T,
  value: string,
): string | undefined => {
  return Object.keys(enumObject).find((key) => enumObject[key] === value);
};

export const getHazardsByUserAndPage = (page: Page): Hazard[] => {
  const userPermissionsSet = new Set(getUserPermissionsList());
  const allHazardsList = getHazardsList();

  const filteredHazardList = allHazardsList.filter((hazard) => {
    const hasPermission = hazard.permissions.some(
      (hazardPerm) => userPermissionsSet.has(hazardPerm) || userPermissionsSet.has(superPermission),
    );
    const isAvailableOnPage = hazard.pages.includes(page);

    return (hasPermission || !hazard.permissions.length) && isAvailableOnPage;
  });

  return filteredHazardList;
};

export const verbatimLevelMarker = "verbatimLevelMarker=";
